import config from '../config/config';

class AppService {
  constructor() {
    this.config = config;
  }
}
export const appService = new AppService();
